import { MenuEventArgs } from '@syncfusion/ej2-react-navigations';
import { useTranslation } from 'react-i18next';
import { ICurrentCellEventArgs } from '../data-types/ICurrentCellEventArgs';
import { ContextMenuItemModelExtended, ContextMenuVisibilityAccessor } from '../utils/SyncfusionContextMenuUtils';
import { IContextMenuItemOptions } from './IContextMenuItemOptions';

export const COMMENT_MENU_ITEM_ID = 'cm-viewComments';

export const useCommentsContextMenuItem = <T>(
    onMenuItemClick?: (args?: ICurrentCellEventArgs<T>) => void,
    getVisibilityState?: ContextMenuVisibilityAccessor
): IContextMenuItemOptions<T> => {
    const { t } = useTranslation();

    const contextMenuItem: ContextMenuItemModelExtended = {
        text: t('viewComments').toString(),
        target: '.e-content',
        id: COMMENT_MENU_ITEM_ID,
        iconCss: 'icon--fluent icon--fluent--comment-20-regular',
        visibilityAccessor: getVisibilityState,
    };

    const handleContextMenuItemClick = (args: MenuEventArgs, currentCellArgs?: ICurrentCellEventArgs<T> | null | undefined) => {
        if (args.item.id === COMMENT_MENU_ITEM_ID && onMenuItemClick) {
            onMenuItemClick(currentCellArgs!);
            return true;
        }
        return false;
    };

    return { contextMenuItem, handleContextMenuItemClick };
};
